/* @jsxImportSource react */

import { type FC } from 'react';

import { ErrorBoundary } from '@packages/shared/src/components/ErrorBoundary/ErrorBoundary';

import { SlotsMinimal } from '../Toolbar/Slots/SlotsMinimal';
import { LinkedLogo } from '../Toolbar/LinkedLogo';
import { MinimalHeaderLayout } from './layout';

export const MinimalHeader: FC = () => (
  <MinimalHeaderLayout>
    <LinkedLogo />
    <ErrorBoundary>
      <SlotsMinimal />
    </ErrorBoundary>
  </MinimalHeaderLayout>
);
